import { isNotFoundFailure } from "@spiriidk/utils";
import { queryOptions, useSuspenseQuery } from "@tanstack/react-query";

import { getLogo } from "../api";

const logoQueryOptions = {
  all: () => ["logo"] as const,
  current: () =>
    queryOptions({
      queryKey: [...logoQueryOptions.all(), "current"] as const,
      queryFn: ({ signal }) => getLogo(signal),
      staleTime: Infinity,
      retry: (failureCount, error) =>
        !isNotFoundFailure(error) && failureCount < 3,
    }),
};

function useLogo() {
  const query = useSuspenseQuery(logoQueryOptions.current());
  return {
    logoUrl: query.data ?? undefined,
  };
}

export { logoQueryOptions, useLogo };
